import * as React from 'react';
import { useEffect, useState } from 'react';
import PublicLayout from '../../../bidder/layouts/PublicLayout';
import { Button, Stack } from '@mui/material';
import axios from '../../../services/axios';

const Instructions = () => {
  const [manuals, setManuals] = useState([]);

  useEffect(() => {
    const fetchManuals = async () => {
      try {
        const response = await axios.get('/api/manuals');
        if (response.data) {
          setManuals(response.data);
        }
      } catch (error) {
        console.error('Error fetching manuals:', error);
      }
    };

    fetchManuals();
  }, []); // пор

  return (
    <>
      <PublicLayout title="Instructions">
        <Stack direction="row" spacing={2}>
          {manuals.map((manual) => (
            <Button variant={'fm-outlined'} key={manual.id} target={'_blank'} href={manual.path}>
              {manual.name}
            </Button>
          ))}
        </Stack>
      </PublicLayout>
    </>
  );
};
export default Instructions;
